import React from "react";

export default function UserRow({ userData1Value, userData2Value, name, register, title }) {

  return (
    <div className="u-d-flex flex-row justify-content-center">
      <div className="col">
        <table className="u-table-user">
          <tr className="u-tr-user">
            <td className="u-td-checkbox">
              <input type="radio" name={name} value={userData1Value} {...register(name)} />
            </td>
            <td className="u-td-value">
              <strong>{title}</strong>{userData1Value}
            </td>
          </tr>
        </table>
      </div>
      <div className="col">
        <table className="u-table-user">
          <tr className="u-tr-user">
            <td className="u-td-checkbox">
              <input type="radio" name={name} value={userData2Value} {...register(name)} />
            </td>
            <td className="u-td-value">
              <strong>{title}</strong>{userData2Value}
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
}